import React from 'react'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  info?: string
  content?: string
  subtitle?: string
}

export const TextChart = ({ title, content, info, subtitle }: React.PropsWithChildren<Props>) => (
  <Card>
    <Card.Title tooltip={info}>{title}</Card.Title>
    <Card.Content>
      <Box justifyContent="center" height="s64" gap="s4">
        <Text size="100" weight="medium" color="grey1000">
          {subtitle}
        </Text>
        <Text size="600" weight="medium" color="grey1000">
          {content}
        </Text>
      </Box>
    </Card.Content>
  </Card>
)
